import { createGlobalStateHook } from '@dateam/ark-react';
var routerGlobal = createGlobalStateHook(null);
export var getRouterRegistration = routerGlobal.getState;
export var setRouterRegistration = routerGlobal.setState;
export default routerGlobal.hook;